<template lang="pug"></template>

<script>
export default {
    name: 'BotaoTerritorioArgentina',
    componentOptions: {
        title: 'Territorio',
        actions: [
            [
                {
                    name: 'Território',
                    iconClass: 'lyra-icon lyra-mapa',
                    showView: false,
                    action: 'abrir',
                    route: 'TerritorioArgentina',
                    nameTranslationKey: 'mensagens.menuLateral.territorio'
                }
            ]
        ]
    },

    methods: {
        abrir() {
            if (this.$route.name !== 'TerritorioArgentina') {
                this.$router.push({ name: 'TerritorioArgentina' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
